import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HotelList_CompanyTopPage_Query } from "./query";

export const useCompanyTopQuery = () => {
	const { data } = useCustomSuspenseQuery(HotelList_CompanyTopPage_Query, { fetchPolicy: "no-cache" });

	return {
		data,
	};
};
